import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IntlMessages from 'util/IntlMessages';
function DeleteItemPopUp(props) {
    return (
        <>
         <Dialog
                open={true}
                onClose={props.onCloseThisPopUp}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                 <DialogTitle></DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <p>Är du säker på att du vill ta bort filter {props.DelItem.RapportName}?</p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className="mr-auto">
                        <button className="btn btn-default" onClick={props.onCloseThisPopUp}>
                            <IntlMessages id="Cancel"/>
                        </button>
                    </div>
                    <div>
                        <button className="btn btn-danger" onClick={() => {
                            props.delRapportAn() 
                            props.onCloseThisPopUp()
                          }}>
                            <IntlMessages id="Remove"/>
                        </button>
                    </div>
                </DialogActions>
            </Dialog>            
        </>
    );
}

export default DeleteItemPopUp;